import EditIcon from "../images/EditIcon.mjs";

/**
 * App icon for Edit operations
 * @see {GlyphIcon}
 * @see {EditIcon}
 */
const AppEditIcon = class extends EditIcon {}

export default AppEditIcon;